import { getInputErrorMessageId } from '../../errors';
import { getInitialFields } from '../actionHelpers';

export const initializeFields = (
  formName,
  formId,
  initialSettings = {}
) => dispatch => {
  const fields = getInitialFields(formName, formId, initialSettings);
  dispatch({
    type: 'INITIALIZE_FIELDS',
    formName,
    formId,
    fields,
  });
};

export const removeFields = (formName, formId) => dispatch => {
  dispatch({
    type: 'REMOVE_FIELDS',
    formName,
    formId,
  });
};

const isFieldValid = (field, value, validity) => {
  let isValid = validity.valid;
  // We’re special-casing the Stipe card field since it is essentially
  // a wrapper.
  if (field.type === 'stripeCard') return validity;
  // Weirdly, ValidityState is reporting tooShort = false when
  // minLength is set to 1 and value.length is 0. So, we are updating
  // manually.
  if (field.minLength && value.length < field.minLength) isValid = false;
  // Instead of including the 'required' attribute, we’re testing
  // independently to avoid the browser-styled validation messages.
  if (field.required && value.length === 0) isValid = false;
  if (field.type === 'checkbox' && field.requiredTrue) {
    isValid = value;
  }
  return isValid;
};

export const updateFieldValidity = (field, value, validity) => dispatch => {
  dispatch({
    type: 'UPDATE_FIELD_VALIDITY',
    fieldName: field.name,
    isValid: isFieldValid(field, value, validity),
    errorMsgId: getInputErrorMessageId(field, value, validity),
  });
};

export const updateFieldValidityManually = (
  field,
  isValid,
  text,
  errorMsgId
) => dispatch => {
  dispatch({
    type: 'UPDATE_FIELD_VALIDITY',
    fieldName: field.name,
    isValid,
    errorMsgId,
    text,
  });
};

export const updateFieldValue = (field, value, validity) => dispatch => {
  dispatch({
    type: 'FIELD_VALUE_CHANGE',
    fieldName: field.name,
    value,
    isValid: isFieldValid(field, value, validity),
    errorMsgId: getInputErrorMessageId(field, value, validity),
  });
};

export const updateFieldFocus = (
  formName,
  formId,
  fieldName,
  eventType
) => dispatch => {
  dispatch({
    type: 'FIELD_FOCUS_CHANGE',
    formName,
    formId,
    fieldName,
    isFocused: eventType === 'focus',
  });
};
